import { render, staticRenderFns } from "./NewContribution.vue?vue&type=template&id=280cea2e&scoped=true"
import script from "./NewContribution.vue?vue&type=script&lang=js"
export * from "./NewContribution.vue?vue&type=script&lang=js"
import style0 from "./NewContribution.vue?vue&type=style&index=0&id=280cea2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cea2e",
  null
  
)

export default component.exports